import { useRef } from 'react';
import { isEqual } from 'lodash';
import { useQuestionnaireContext } from '@/components/Questionnaire/QuestionnaireProvider';
import getListOrTableField from '@/helpers/getListOrTableField';

type Props = {
  aiAgent: { fieldOutputs: string[] };
};

const useOutputFieldKeys = ({ aiAgent }: Props): string[] => {
  const {
    formMethods,
    fieldsByKey,
    fieldsById,
  } = useQuestionnaireContext();
  const storedFieldKeys = useRef<string[]>([]);

  const outputFieldKeys = aiAgent.fieldOutputs
    ? aiAgent.fieldOutputs.flatMap((fieldKey) => {
      const field = fieldsByKey[fieldKey];
      if (!field) {
        return [];
      }
      const listField = getListOrTableField({
        fieldId: field?.listFieldTemplateId,
        fieldsById,
      });

      if (listField) {
        const listFieldValues = formMethods.getValues()[listField.key] as unknown;
        if (!listFieldValues || !Array.isArray(listFieldValues) || listFieldValues?.length === 0) {
          return [];
        }
        return listFieldValues.map((__, index) => `${listField.key}[${index}].${fieldKey}`);
      }
      return fieldKey;
    })
    : [];

  if (!isEqual(outputFieldKeys, storedFieldKeys.current)) {
    storedFieldKeys.current = outputFieldKeys;
  }

  return storedFieldKeys.current;
};

export default useOutputFieldKeys;